var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import React, { useContext, useEffect } from 'react';
import { I18nContext } from '../_contexts/I18nContext';
import Container from '@/pages/business/components/Container/outStandingPartners';
import { BaseContext } from '@/contexts/BaseContext';
import { initLogger } from '@/pages/business/utils/lib';
import { jumpToAnchor } from '@/utils';
import { loadCookiebanner } from '@/utils/cookieBanner';
import { UseCheckIdHost } from '../hooks/useCheckIdHost';

const init = baseContext => {
  if (typeof window !== 'undefined') {
    initLogger({
      page_name: 'outstanding-partners',
      region: baseContext.region
    });
    jumpToAnchor();
  }
};

const OutStandingPartners = ({
  i18nData,
  casesData,
  dropdownData
}) => {
  const baseContext = useContext(BaseContext);
  UseCheckIdHost();
  useEffect(() => {
    loadCookiebanner(baseContext.language.current || 'en');
  }, []);
  init(baseContext);
  return /*#__PURE__*/React.createElement(I18nContext.Provider, {
    value: i18nData
  }, /*#__PURE__*/React.createElement(Container, {
    casesData: casesData,
    dropDownData: dropdownData
  }));
};

OutStandingPartners.getInitialProps = context => __awaiter(void 0, void 0, void 0, function* () {
  const {
    ctx
  } = context;
  const i18nData = yield ctx === null || ctx === void 0 ? void 0 : ctx.service.business.i18n();
  const cases = yield ctx === null || ctx === void 0 ? void 0 : ctx.service.business.getOutstandingPartnersCases();
  const dropdownData = yield ctx === null || ctx === void 0 ? void 0 : ctx.service.business.getDropdown();
  return {
    TDK: {
      title: i18nData.TTS_SEO_partner_title || '',
      description: i18nData.TTS_SEO_partner_desc || '',
      keywords: i18nData.TTS_SEO_partner_keywords || ''
    },
    i18nData,
    casesData: [...cases].sort((a, b) => (a === null || a === void 0 ? void 0 : a.name.toUpperCase()) - (b === null || b === void 0 ? void 0 : b.name.toUpperCase())),
    dropdownData
  };
});

export default OutStandingPartners;